import {
  DATE_VALIDATION_TYPE,
  NUMBERS,
  VALIDATION_TYPES
} from '@/utils/constants/commonConstants';

/**
 * Creates a custom rules object with the specified columns
 * @param {Array} columns - Array of column definitions
 * @returns {Object} Custom rules object with type, size, and columns
 */
const createCustomRules = (columns) => ({
  type: 'text/csv',
  size: NUMBERS.TwoFiveSixHundred,
  columns
});

/**
 * Creates a column definition with default alphanumeric type and char limits
 * @param {string} name - Column name
 * @param {boolean} required - Whether the column is required
 * @param {string} type - Column type (default: 'alphanumeric')
 * @param {boolean} includeCharLimits - Whether to include min/max character limits
 * @param {string} dateType - Date type for date validation (optional)
 * @param {boolean} unique - Whether the column values must be unique across all rows
 * @returns {Object} Column definition object
 */
const createColumn = (
  name,
  required = true,
  type = 'alphanumeric',
  includeCharLimits = false,
  dateType = null,
  unique = false
) => {
  const column = {
    name,
    required,
    type
  };

  if (includeCharLimits && type === 'alphanumeric') {
    column.minChar = NUMBERS.One;
    column.maxChar = NUMBERS.TwoFiveFive;
  }

  if (dateType) {
    column.dateType = dateType;
  }

  if (unique) {
    column.unique = unique;
  }

  return column;
};

export const customRules = createCustomRules([
  createColumn('Reward ID', true, VALIDATION_TYPES.NUMBER, true),
  createColumn('Reward Name', true, VALIDATION_TYPES.STRING, true),
  createColumn('Code', true, VALIDATION_TYPES.STRING, false),
  createColumn(
    'Expiry date',
    false,
    VALIDATION_TYPES.DATE,
    false,
    DATE_VALIDATION_TYPE.START_DATE
  ),
  createColumn('Code Used', false, VALIDATION_TYPES.YES_NO, false)
]);

export const customRulesRewards = createCustomRules([
  createColumn('ID', false, 'number', false, null, false),
  createColumn('ERP Code', false, 'string'),
  createColumn('Reward Code', true, 'string', false, null, true),
  createColumn('Reward Type', true, 'string'),
  createColumn('GTIN', false, 'string'),
  createColumn('Reward Start Date', true, 'date', false, 'startDate'),
  createColumn('Reward End Date', true, 'date', false, 'endDate'),
  createColumn('Quota', false, 'string'),
  createColumn('Inventory', false, 'string'),
  createColumn('Loyalty URL', false, 'string'),
  createColumn('Coupon Based Loyalty Reward', false, 'string'),
  createColumn('Segment External Id', false, 'string'),
  createColumn('Show On HomePage', false, 'string'),
  createColumn('Reward Point/Price', false, 'string'),
  createColumn('Unlimited Quantity', false, 'string'),
  createColumn('Expiration date', false, 'string'),
  createColumn('Route Type Id', false, 'string'),
  createColumn('Price', false, 'string'),
  createColumn('Title (en)', true, 'string'),
  createColumn('Long Description (en)', true, 'string'),
  createColumn('Main Category (en)', false, 'string'),
  createColumn('Sub Category (en)', false, 'string'),
  createColumn('Title (es_MX)', true, 'string'),
  createColumn('Long Description (es_MX)', true, 'string'),
  createColumn('Main Category (es_MX)', false, 'string'),
  createColumn('Sub Category (es_MX)', false, 'string'),
  createColumn('Limit Per Store', false, 'number')
]);
